import { get } from 'svelte/store';
import { dataStore } from './store';

/**
 * Send a raw get request to BTS.
 *
 * @param {string} route The REST route. Should have the same format as the return value of URLSearchParams.toString.
 * @param {number} v Version of the API to use
 */
async function rawGet(route, proxy = 'proxy') {
	let response;
	if (proxy === 'vehicle' ) {
		response = await fetch(wordpress_object.proxy_url_vehicle + '&route=' + route);
	} 
	if (proxy === 'filter' ) {
		response = await fetch(wordpress_object.proxy_url_filter + route);
	}
	if (proxy === 'proxy' ) {
		response = await fetch(wordpress_object.proxy_url + route);
	}

	return response.json();
}

/**
 * Get a vehicle and it's details
 *
 * @export
 * @param {number} id The ID of the vehicle
 */
export function getVehicle(id) {
	return rawGet(id, 'vehicle');
}

/**
 * Get filters per vehicle type
 *
 * @export
 * @param {number} vt The key of vehicle type
 */
export function getFilters(filters = {}) {
	if (!filters.vt || filters.vt === null) return {};

	const paramString = '&' +
		Object.entries(filters)
			.filter(([key, value]) => !!value)
			.map(([key, value]) => `${key}=${value}`)
			.join('&');

	return rawGet(paramString, 'filter');
}

/**
 * Update the results in store with the response of a single search.
 *
 * @param {string} filters An object containing all filters for this request.
 * @param {number} perPage The number of products per page to fetch.
 * @export
 */
export function performSearch() {
	const { filters, page } = get(dataStore);

	// Transform the filters object into a param string;
	const paramString = '&' +
		Object.entries({ ...filters, page })
			.filter(([key, value]) => !!value)
			.map(([key, value]) => `${key}=${value}`)
			.join('&');
	dataStore.update(data => ({
		...data,
		loading: true,
	}));

	rawGet(paramString).then(res => {
		dataStore.update(data => ({
			...data,
			totalCount: res.totalVehicle,
			results: res.result,
			loading: false,
		}));
	});
}
